module.exports = __webpack_public_path__ + "assets/img/home_cs_8.a416ab72.png";